import { httpsCallable } from "firebase/functions";
import { functions } from "../../../shared/libs/firebaseConfig";

export const REVIEW_PAGE_SIZE = 10;
const pending = new Map();

export function listHomepageReviews(courseId, cursor = null) {
  const request = { ...(courseId === undefined ? { mode: "all-enabled" } : { courseId }), pageSize: REVIEW_PAGE_SIZE, ...(cursor ? { cursor } : {}) };
  const key = JSON.stringify(request);
  if (pending.has(key)) return pending.get(key);
  const promise = httpsCallable(functions, "listHomepageCourseReviews")(request).then(({ data }) => {
    if (!Array.isArray(data?.reviews) || data.reviews.length > REVIEW_PAGE_SIZE ||
        (data.nextCursor != null && typeof data.nextCursor !== "string")) throw new Error("invalid-public-review-response");
    return {
      // Presentation allowlist only. Publication authorization belongs to the callable.
      reviews: data.reviews.map(({ reviewId, courseName, authorDisplayName, authorAvatarUrl, reviewText, createdAt }) => ({
        reviewId, courseName, authorDisplayName, authorAvatarUrl, reviewText, createdAt,
      })),
      nextCursor: data.nextCursor || null,
    };
  }).finally(() => pending.delete(key));
  pending.set(key, promise);
  return promise;
}
